import { Dossier } from '@sc/data-access-models';

export class SetDossiersToValidateAction {
  static readonly type = '[SetDossiersToValidateAction] Set dossiers';

  constructor(public payload: Dossier[]) {}
}

export class SetNewDossiersToValidateAction {
  static readonly type = '[SetNewDossierToValidateAction] Set new dossier';

  constructor(public payload: Dossier[]) {}
}

export class ReplaceDossiersToValidateAction {
  static readonly type = '[ReplaceDossiersToValidateAction] Replace dossiers';

  constructor(public payload: Dossier[]) {}
}
